<template>
  <base-section id="faqs">
    <base-section-heading title="Frequently Asked Questions">
      Climate Action Truro is relatively new, and here are some of the questions that have come our way.
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis illum veniam cum dolores ratione commodi beatae quas maxime, laboriosam excepturi solut!
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
    <span class="trace">Faqs.vue</span>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          title: 'When did C.A.T. start?',
          // icon: 'mdi-fountain-pen-tip',
          text: 'Climate Action Truro began in 2018 with a group of citizens who were concerned about the environment, and thought that Truro should be more proactive.  A group of about 18 citizens signed a petition to establish a Climate Action Committee, and another 60 citizens signed onto that petition before the Annual Town Meeting of 2019 approved the formation of the Committee.  Core members of the group continued to discuss how citizens could remain active in the efforts.',
        },
        {
          title: 'What\'s with the Cat logo?',
          // icon: 'mdi-fountain-pen-tip',
          text: 'Other than our initials spell CAT, the Puma is Truro Central School\'s mascot.  And the building of the Puma Park playground by Truro volunteers was a great example of community involvement, the kind of involvement needed to rescue us from the dangers of climate change.',
        },
        {
          title: 'How does this work with the Town Climate Action Committee?',
          // icon: 'mdi-fountain-pen-tip',
          text: 'Climate Action Truro is a group of concerned citizens, and we think there is enough overlap of people with both the Climate Action Committee and the Energy Committee that the role the CAT group can play in supporting the two multi-member committees policies and programs will easily sort itself out. There\'s so much to do, that we don\'t foresee redundancies. Truro has other examples of successful partnerships like this: e.g., the Truro Conservation Commission and the 501(c)3 Truro Conservation Trust, and the Truro Library Trustees and the Friends of the Truro Library.',
        },
        {
          title: 'How can I get involved and help?',
          // icon: 'mdi-fountain-pen-tip',
          text: 'Your help would be great!  You can start by browsing the information we have posted on this site, and taking personal actions to help our climate.  If you\'d like to volunteer time, we have a number of active projects underway you can join.  Each project has a contact person who can tell you more about that project.  And if you have a new area you are passionate about, feel free to suggest a project and take the iniative to run with it -- you might just find other volunteers ready to help you.',
        },
        /*
        {
          title: 'Retina Ready',
          icon: 'mdi-cellphone',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Easily Customizable',
          icon: 'mdi-pencil-box-outline',
        },
        {
          title: 'Image Parallax',
          icon: 'mdi-image-size-select-actual',
        },
        {
          title: 'Seo Optimized',
          icon: 'mdi-ice-pop',
        },
        {
          title: '24/7 Support',
          icon: 'mdi-help-circle-outline',
        },
        */
      ],
    }),
  }
</script>
